import { render } from "./DefLinkBrown.vue?vue&type=template&id=0481bcdf&scoped=true"
import script from "./DefLinkBrown.vue?vue&type=script&lang=js"
export * from "./DefLinkBrown.vue?vue&type=script&lang=js"

import "./DefLinkBrown.vue?vue&type=style&index=0&id=0481bcdf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0481bcdf"]])

export default __exports__